import { fetcher } from '../../configure'
import { PlannedRoute } from './dto/planned-route.dto'

export type SavePlannedRouteRequest = {
    route: PlannedRoute
}

export type SavePlannedRouteResponse = {
	success: boolean
	route?: PlannedRoute | null
}

export type SavePlannedRouteEndpoint = (
	request: SavePlannedRouteRequest
) => Promise<SavePlannedRouteResponse>

export const savePlannedRouteEndpoint: SavePlannedRouteEndpoint = async (request) => {
	return await fetcher({
		method: 'post',
		path: `/users/planned-routes/save`,
		body: request,
	})
}